import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialSlackIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M9.3329 2C8.22733 2.00082 7.33257 2.89623 7.33339 3.99959 7.33257 5.10296 8.22814 5.99837 9.33372 5.99918H11.334V4.00041C11.3349 2.89704 10.4393 2.00163 9.3329 2 9.33372 2 9.33372 2 9.3329 2zM9.3329 7.33333H4.00033C2.89476 7.33415 1.99919 8.22956 2 9.33293 1.99837 10.4363 2.89394 11.3317 3.99951 11.3333H9.3329C10.4385 11.3325 11.334 10.4371 11.3332 9.33374 11.334 8.22956 10.4385 7.33415 9.3329 7.33333zM22 9.33293C22.0008 8.22956 21.1052 7.33415 19.9997 7.33333 18.8941 7.33415 17.9985 8.22956 17.9993 9.33293V11.3333H19.9997C21.1052 11.3325 22.0008 10.4371 22 9.33293zM16.6666 9.33293V3.99959C16.6674 2.89704 15.7727 2.00163 14.6671 2 13.5615 2.00082 12.666 2.89623 12.6668 3.99959V9.33293C12.6651 10.4363 13.5607 11.3317 14.6663 11.3333 15.7719 11.3325 16.6674 10.4371 16.6666 9.33293zM14.6663 22C15.7719 21.9992 16.6674 21.1038 16.6666 20.0004 16.6674 18.897 15.7719 18.0016 14.6663 18.0008H12.666V20.0004C12.6651 21.103 13.5607 21.9984 14.6663 22zM14.6663 16.6659H19.9997C21.1052 16.665 22.0008 15.7696 22 14.6663 22.0016 13.5629 21.1061 12.6675 20.0005 12.6659H14.6671C13.5615 12.6667 12.666 13.5621 12.6668 14.6654 12.666 15.7696 13.5607 16.665 14.6663 16.6659zM2 14.6663C1.99919 15.7696 2.89476 16.665 4.00033 16.6659 5.1059 16.665 6.00147 15.7696 6.00066 14.6663V12.6667H4.00033C2.89476 12.6675 1.99919 13.5629 2 14.6663zM7.33339 14.6663V19.9996C7.33176 21.103 8.22733 21.9984 9.3329 22 10.4385 21.9992 11.334 21.1038 11.3332 20.0004V14.6679C11.3349 13.5645 10.4393 12.6691 9.33372 12.6675 8.22733 12.6675 7.33257 13.5629 7.33339 14.6663z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
